import { observer } from 'mobx-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FuseReadOnlyComponent from './FuseReadOnlyComponent';
import FuseTextfield from './FuseTextfield';

/**
 * This is a fuse text field with the ReadOnly property changed to render what we need it to, according to
 * the new policy specs. A new component is used since the readOnly property of the original component is already used
 * as a sort-of-an-alias for 'disable'. Even if it's not used across the site, its assumed QA are somewhat overloaded
 * and if its possible for policy stuff to be merged without a general regress, that's preferred.
 * Long term we would ideally get rid of this and use the original component, or reimplement the old component into this
 * one, if the old one is too much spaghetti
 * */
class FuseReadOnlyTextfield extends Component {
    static propTypes = {
        defaultValue: PropTypes.string,
        ...FuseReadOnlyComponent.PropType,
        ...FuseTextfield.PropType,
    };

    render() {
        const { label, store, defaultValue } = this.props;

        return <FuseReadOnlyComponent
            component={FuseTextfield}
            readOnlyLabel={label}
            readOnlyValue={store.value || defaultValue}
            {...this.props}
        />;
    }
}

export default observer(FuseReadOnlyTextfield);
